/* eslint-disable */
import { useEffect, useState } from "react";

import ReactDatePicker, { registerLocale } from "react-datepicker";
import * as locale from "date-fns/locale";

import { useAppSelector } from "../../store/store";

registerLocale("de", locale["de"]);
registerLocale("en", locale["enGB"]);
registerLocale("fr", locale["frCH"]);
registerLocale("it", locale["itCH"]);

interface DatePickerProps {
  className: string;
  excludeDates: string[];
  id: string;
  maxDate?: string | Date;
  minDate?: string | Date;
  onChange: (updatedData: Date | null) => void;
  placeholder: string;
  required: boolean;
  showIcon?: boolean;
  value?: Date | null;
  wrapperClassName: string;
}

const DatePicker = ({
  className,
  excludeDates,
  id,
  maxDate,
  minDate,
  onChange,
  placeholder,
  required = false,
  value = null,
  showIcon = false,
  wrapperClassName
}: DatePickerProps) => {
  const [currentValue, setCurrentValue] = useState<Date | null | undefined>(value);
  const minDateObj = minDate ? new Date(minDate) : null;
  const maxDateObj = maxDate ? new Date(maxDate) : null;
  const excludedDatesObj = excludeDates.map((date) => new Date(date));
  const language = useAppSelector(s => s.app.appLanguage);

  useEffect(() => {
    if (value !== currentValue) setCurrentValue(value);
  }, [value]);

  return (
    <ReactDatePicker
      calendarStartDay={1}
      className={className}
      dateFormat={"P"}
      excludeDates={excludedDatesObj}
      id={id}
      locale={language}
      maxDate={maxDateObj}
      minDate={minDateObj}
      onChange={(date: Date) => {
        setCurrentValue(date);
        onChange(date);
      }}
      placeholderText={placeholder}
      required={required}
      selected={currentValue}
      showIcon={showIcon}
      showPopperArrow={false}
      wrapperClassName={wrapperClassName}
    />
  );
};

export default DatePicker;
